import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import "../../assets/stylesheet/multiSelectInputType.css";
import baseUrl from "../../services/baseUrl";
import ApiRequest from "../../services/apiService";
import { ShowToastUtil } from "../../utilities/showToastUtil";
import { options } from "numeral";
import GetUserData from "../../utilities/getUserDetails";
import { parseJSON } from "date-fns";
import { ClipLoader } from "react-spinners"; // Import the ClipLoader

const SingleSelectSobDropDown = ({ onSobSelect, onAllTouchpointSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [sobs, setSobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(
    localStorage.getItem("sobFilter")
      ? { SobName: localStorage.getItem("sobFilter") }
      : null
  );
  const [userData, setUserData] = useState(GetUserData() || {});
  const [IsLoading, setIsLoading] = useState(false);

  // const placeholder = localStorage.getItem('sobFilter') || (selectedItem
  //   ? `${selectedItem.SobName || selectedItem}`
  //   : `Overall`);
  const isAllTouchpoints =
    localStorage.getItem("touchpointFilter") ||
    localStorage.getItem("isAllTouchpoints")
      ? true
      : false;
  const placeholder = isAllTouchpoints
    ? "All Touchpoints"
    : (selectedItem ? selectedItem.SobName : "") || "Overall";
  // const placeholder = selectedItem ? selectedItem.TouchpointName : "Select Touchpoint";;
  const fetchSobData = async () => {
    setIsLoading(true);

    try {
      const params = new URLSearchParams({
        queryMode: "fetchSobs",
        touchpointSearchFilter: searchTerm,
        projectFilter: localStorage.getItem("projectFilter") || "",
        userRole: userData.UserRole,
        userCode: userData.UserCode,
      });
      const url = `${baseUrl()}/nps/GetNpsGlobalFilters?${params.toString()}`;
      const responseData = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (responseData.Data && responseData.IsSuccess) {
        setIsLoading(false);
        const data = responseData.Data;
        setSobs(data.Sobs || []);
      } else {
        console.log("No data available for selected range");
        return;
      }
    } catch (error) {
      console.error("Error fetching Sob filters data:", error);
      // ShowToastUtil("Please try logging in again", "error");
    }
  };
  useEffect(() => {
    fetchSobData();
  }, []);

  useEffect(() => {
    fetchSobData();
  }, [searchTerm]);

  const handleSelect = (sob) => {
    onSobSelect(sob.SobName);
    setSelectedItem(sob);
    localStorage.removeItem("touchpointFilter");
    setIsOpen(false);
    localStorage.removeItem("isAllTouchpoints");
    onAllTouchpointSelect(false);
    window.location.reload();
  };

  const clearSobFilter = () => {
    setSelectedItem("");
    localStorage.removeItem("sobFilter");
    localStorage.removeItem("touchpointFilter");
    onAllTouchpointSelect(false);
    localStorage.removeItem("isAllTouchpoints");
    window.location.reload();
  };

  const showAllTouchpoints = () => {
    onAllTouchpointSelect(true);
    localStorage.removeItem("sobFilter");
    setSelectedItem("All Touchpoints");
    localStorage.setItem("isAllTouchpoints", true);
    // window.location.reload();
  };
  return (
    <div className="d-flex align-items-center">
      <Dropdown
        className="singleSelectTouchpoint"
        show={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
      >
        <Dropdown.Toggle
          as={Button}
          variant="outline-secondary"
          className="text-right transparent-background"
        >
          {placeholder}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
          <Dropdown.Item onClick={clearSobFilter} as="div">
            <Form.Check
              type="checkbox"
              label="Deselect"
              checked={!selectedItem && !isAllTouchpoints}
              onClick={clearSobFilter}
              title="Deselect the current selection"
            />
          </Dropdown.Item>
          <Dropdown.Item as="div">
            <Form.Control
              type="select"
              label="All Touchpoints"
              value="All Touchpoints"
              onClick={showAllTouchpoints}
              className="singleSelectTouchpointHover"
            />
          </Dropdown.Item>
          <Dropdown.Item as="div">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </InputGroup>
          </Dropdown.Item>
          {IsLoading ? (
            <div className="d-flex justify-content-center align-items-center p-3">
              <ClipLoader size={35} color={"#123abc"} loading={IsLoading} />
            </div>
          ) : (
            sobs.map((option) => (
              <Dropdown.Item
                key={option.SobId}
                as="div"
                onClick={() => handleSelect(option)}
              >
                {/* Replace Form.Control with a span or div */}
                <div className="dropdown-text">{option.SobName}</div>
              </Dropdown.Item>
            ))
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SingleSelectSobDropDown;
